<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:18%">
          	  <el-date-picker v-model="jdquery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <el-form-item>
	            <el-input placeholder="京东订单号" clearable v-model="jdquery.orderId" @keyup.enter.native="getlists" @change="ischange=true" style="width:100%"></el-input>
	        </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
          </el-form-item>

          <!-- 京东预存款 -->
			    <el-form-item v-if="jdmoneys.money > 0 && jdmoneys.money!=''">
              <template slot-scope="scope">
                  <span style="color:#909399" v-if="jdmoneys.status==0">当前京东预存款：<em style="color:#E6A23C;font-style:normal;font-weight:bold">￥{{jdmoneys.money}}</em></span>
                  <span style="color:#909399" v-if="jdmoneys.status==1">当前京东预存款：<em style="color:rgb(248, 93, 15);font-style:normal;font-weight:bold">￥{{jdmoneys.money}}（预存款不足，请及时充值）</em></span>		
              </template>
          </el-form-item>

      </el-form>
      
      <div class="backborder2" style="margin-top:10px">
          <el-table :data="lists" v-loading="listsLoading">
              <el-table-column prop="id" label="明细id" align="left"></el-table-column>
              <el-table-column prop="orderId" label="业务编号" align="left"></el-table-column>
              <el-table-column prop="tradeTypeName" label="业务类型名称" width="160" align="center"></el-table-column>
              <el-table-column prop="tradeNo" label="京东交易号" width="140" align="center"></el-table-column>
              <el-table-column prop="amount" label="金额" width="140" align="center"></el-table-column>
              <el-table-column prop="notePub" label="备注" width="160" align="center"></el-table-column>
              <el-table-column prop="createdDate" label="时间" width="180" align="center"></el-table-column>
              <el-table-column label="操作" align="center" width="100">
                  <template slot-scope="scope">
                      <el-button size="mini" type="primary" icon="el-icon-search" circle @click="getjdorderdetails(scope.row)" v-if="scope.row.tradeTypeName=='实物/礼品卡余额支付'"></el-button>
                  </template>
              </el-table-column>
          </el-table>
          <div class="block">
              <!--分页begin-->
              <el-pagination
                  @size-change="jdlistspageChange"
                  @current-change="jdlistsCurrentChange"
                  :current-page="jdquery.p"
                  :page-sizes="[10, 20, 50]"
                  :page-size="jdquery.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="rows">
              </el-pagination>
              <!--分页end-->
          </div>
      </div>
      

      <el-dialog title="明细详情" :visible.sync="detailDialog"  width="85%" top="10vh">
          <el-table :data="logdetails" border v-loading="customerdetailloading">
              <el-table-column type="expand">
                  <template slot-scope="props">
                      <el-table :data="props.row.goods">
                          <el-table-column prop="name" label="商品名称" align="left"></el-table-column>
                          <el-table-column prop="skuId" label="sku" width="150"></el-table-column>
                          <el-table-column prop="price" label="价格" width="100" align="center"></el-table-column>
                          <el-table-column prop="nakedPrice" label="裸价" width="100" align="center"></el-table-column>
                          <el-table-column prop="num" label="数量" width="100" align="center"></el-table-column>
                          <el-table-column prop="taxPrice" label="税费" width="100" align="center"></el-table-column>
                          <el-table-column prop="tax" label="税率（%）" width="100" align="center"></el-table-column>
                          <el-table-column prop="total" label="小计" width="100" align="center"></el-table-column>
                          <el-table-column prop="type" label="商品类型" width="100" align="center">
                              <template slot-scope="ppprops">
                                  <span v-if="ppprops.row.type==0">普通</span>
                                  <span v-if="ppprops.row.type==1">附件</span>
                                  <span v-if="ppprops.row.type==2">赠品</span>
                              </template>
                          </el-table-column>
                      </el-table>
                  </template>
              </el-table-column>

				      <el-table-column label="京东订单号" prop="ordernumber"></el-table-column>		
				      <el-table-column label="订单裸价" prop="orderNakedPrice" width="140" align="center"></el-table-column>
              <el-table-column label="订单税费" prop="orderTaxPrice" width="140" align="center"></el-table-column>
              <el-table-column label="运费" prop="freight" width="140" align="center"></el-table-column>
              <el-table-column label="订单价格" prop="orderPrice" width="110" align="center"></el-table-column>
          </el-table>

          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="detailDialog = false">取 消</el-button>
          </div>
		  </el-dialog>
          
  </div>
  </transition> 
</template>

<script>
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      ischange:false,
      jdquery: {
          act:'getfundlists',
          token:this.$cookies.get('token'),
          date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
          orderId:'',
          p:1,
          rollpage:10
      },
      listsLoading:false,
      lists:[],
      rows:0,
      jdmoneys:[],
      logdetails:[],
      detailDialog:false,
      detailLoading:false,

    }  
     
  },
  mounted(){
     this.getlists();
     this.getjdlastmoney(); //京东预存款剩余余额
  },
  methods:{
     //获取对账信息列表
     getlists() {
         if(this.ischange==true) {this.jdquery.p=1;this.jdquery.rollpage=10;}
          this.listsLoading=true;
          var resource = this.$resource(this.url);
          resource.query(this.jdquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsLoading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
	                this.rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.listsLoading=false;
              }
          }).catch((res) => {
              this.listsLoading=false;
          });
     },

     jdlistspageChange(val) {
        this.jdquery.rollpage = val;
        this.getlists();
      },
      jdlistsCurrentChange(val) {
        this.jdquery.p = val;
        this.getlists();
      },


      /** 获取京东进货预存金额 **/
		  getjdlastmoney() {
          var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdlastmoney',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
            }else{
              this.jdmoneys = JSON.parse(Base64.decode(res.data.Data));
            }
          }).catch((res) => {
            
          });
		  },
      
      /** 获取明细详情 **/
      getjdorderdetails(item) {
          this.detailDialog=true;
          this.detailLoading=true;
          var resource = this.$resource(this.url);	
          resource.query({act:'getjdorders',token:this.$cookies.get('token'),'orderId':item.orderId}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.detailLoading=false;
              }else{
                  this.logdetails = JSON.parse(Base64.decode(res.data.Data));
                  this.detailLoading=false;
              }
          }).catch((res) => {
              this.detailLoading=false;
          })
      }

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Mallsaledays.vue